import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { loginWithKakao } from "../../api/auth";



const KakaoAuthPage = () => {
    const navigate = useNavigate();
    const { refreshAuth } = useAuth()

    // 현재 브라우저 URL에서 쿼리 파라미터 추출
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code"); // ?code=xxxxxx 부분

    useEffect(() => {
        const handleKakaoLogin = async () => {
            if (!code) return;
            
            
            try {
                const data = await loginWithKakao(code);
    
                // 서버 응답 구조에 따른 분기 처리
                if (data?.success && (data?.status === "OK" || data?.status === "REGISTERED")) {
                    const isSuccess = await refreshAuth();

                    if (isSuccess) {
                        navigate("/onboarding", { replace: true });
                    }
                
                } else {
                    alert("오류 발생: 서버 응답이 올바르지 않습니다.");
                    navigate("/auth/login");
                }
            } catch (err) {
                // 서비스 함수에서 throw한 에러가 여기서 잡힙니다.
                alert("로그인 중 오류가 발생했습니다.");
                navigate("/auth/login");
            }
        };
    
        handleKakaoLogin();
    }, [code, navigate, refreshAuth]);

    return (
        <div
            style={{
                width: "100%",
                height: "100vh", // 화면 전체 높이
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            {/* <span>code: {code}</span> */}
            {/* <Loader color="#5751FFCC"/> */}
            <span>
                로딩 중
            </span>
        </div>
    );
};

export default KakaoAuthPage;
